import { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Button, Tooltip, Whisper } from 'rsuite';
import { getTipoPromocaoList, setConsolidadoData, setEnderecoRaio, setGenerateReportData } from '../../../../../../actions/actionsModuloRelatorio';
import { changeCache, changeValue, getItensFiltro } from '../../../../../../actions/actionsPainelGeral';
import DndColumn from './DndColumn';
import DndMovableItem from './DndMovableItem';
import { DndSelectRaio } from './DndSelectRaio';

import { getModelPanel } from '../../../InfoPanel/utils';
import { filtrosDataType, flagData } from '../../utils';

import chevronLeftIcon from '../../../../../../assets/icons/icon_chevron-double-left.svg';
import chevronRightIcon from '../../../../../../assets/icons/icon_chevron-double-right.svg';

const DndComponent = ({ dndItems, columnTitles, elementLeft, elementRight, dndName, functions, products, enderecoHandlers, cnpjHandlers }) => {
  const [items, setItems] = useState(dndItems);
  const [timer, setTimer] = useState(null);

  const dispatch = useDispatch();

  const { filtrosData, moduloRelatorioData, showModalConfirmDownload, tipoPromocaoSelectData, clienteData, endereco, cnpj } = useSelector(
    state => ({
      filtrosData: state.painelGeralDataReducer.filtrosData,
      moduloRelatorioData: state.moduloRelatorioDataReducer?.moduloRelatorioData,
      showModalConfirmDownload: state.moduloRelatorioDataReducer?.showModalConfirmDownload,
      tipoPromocaoSelectData: state.moduloRelatorioDataReducer?.tipoPromocaoSelectData,
      endereco: state.moduloRelatorioDataReducer?.endereco,
      cnpj: state.moduloRelatorioDataReducer?.cnpj,
      clienteData: state.clienteDataReducer?.clienteData,
    }),
    shallowEqual,
  );

  const handleOnOpen = listName => {
    const neutro = () => null;
    const service = {
      PMC: neutro,
      'Rebaixa de preço': neutro,
      'Marca própria': neutro,
      'Flag promoção': neutro,
      'Tipo promoção': () => dispatch(getTipoPromocaoList()),
      'CNPJ da Loja': () => cnpjHandlers.handleSearchCNPJ(),
      Endereço: neutro,
      Produto: () => functions?.onSearchProducts(),
    };

    const defaultHandler = () => dispatch(getItensFiltro(getModelPanel(filtrosData, '', filtrosDataType[listName]), filtrosDataType[listName]));

    const handler = service[listName] || defaultHandler;
    return handler();
  };

  const shouldUpdateFiltrosData = name => !['Tipo promoção', 'Flag promoção', 'PMC', 'Rebaixa de preço'].includes(name);

  const handleAddItem = (name, value, item) => {
    const filterKey = filtrosDataType[name];
    const newValues = moduloRelatorioData[filterKey]?.concat(value);

    dispatch(setGenerateReportData(filterKey, newValues));

    if (shouldUpdateFiltrosData(name)) {
      const reducerKey = name === 'Conteúdo' ? 'conteudo' : filterKey;
      const newCache = filtrosData[reducerKey]?.cache?.concat(item);
      dispatch(changeValue(newValues, reducerKey));
      dispatch(changeCache(reducerKey, newCache));
    }
  };

  const handleRemoveItem = (name, value) => {
    const filterKey = filtrosDataType[name];
    const newValues = moduloRelatorioData[filterKey]?.filter(i => i !== value);
    dispatch(setGenerateReportData(filterKey, newValues));
    if (shouldUpdateFiltrosData(name)) {
      const reducerKey = name === 'Conteúdo' ? 'conteudo' : filterKey;
      const newCache = filtrosData[reducerKey].cache.filter(item => item.value !== value);
      dispatch(changeValue(newValues, reducerKey));
      dispatch(changeCache(reducerKey, newCache));
    }
  };

  const handleSelect = (item, name) => {
    if (name === 'Endereço') {
      enderecoHandlers.handleSelectEndereco(item);
      return;
    }

    if (name === 'CNPJ da Loja') {
      cnpjHandlers.handleSelectCNPJ(item);
      return;
    }

    if (name === 'Produto') {
      if (products?.value.includes(item.identificador)) {
        functions?.handleRemoveProduct(item);
        handleRemoveItem(name, item.identificador);
      } else {
        functions?.handleAddProduct(item);
        handleAddItem(name, item.identificador);
      }
    }

    if (moduloRelatorioData[filtrosDataType[name]]?.includes(item.value)) {
      handleRemoveItem(name, item.value);
    } else {
      handleAddItem(name, item.value, item);
    }
  };

  const handleClean = name => {
    dispatch(setGenerateReportData(filtrosDataType[name], []));
    dispatch(changeCache(filtrosDataType[name], []));
    dispatch(changeValue([], filtrosDataType[name]));

    if (name === 'Produto') {
      functions?.handleCleanProduct();
    }

    if (name === 'Endereço') {
      enderecoHandlers.handleCleanEndereco();
    }

    if (name === 'CNPJ da Loja') {
      cnpjHandlers.handleCleanCNPJ();
    }
  };

  const defaultSearch = (inputValue, name) => {
    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      dispatch(getItensFiltro(getModelPanel(filtrosData, inputValue, filtrosDataType[name]), filtrosDataType[name]));
    }, 500);

    setTimer(newTimer);
  };

  const handleSearch = (inputValue, name) => {
    const searchFunctions = {
      Endereço: () => enderecoHandlers?.handleSearchEndereco(inputValue),
      Produto: () => functions?.onSearchProducts(inputValue),
      'CNPJ da Loja': () => cnpjHandlers?.handleSearchCNPJ(inputValue),
    };

    const search = searchFunctions[name] || (() => defaultSearch(inputValue, name));
    return search();
  };

  const setSelectDataFilter = name => {
    const data = {
      Endereço: endereco?.lista,
      'Flag promoção': flagData,
      'Tipo promoção': tipoPromocaoSelectData,
      Produto: products?.list,
      'CNPJ da Loja': cnpj?.lista,
      PMC: flagData,
      'Rebaixa de preço': flagData,
      'Marca própria': flagData,
      default: filtrosData[filtrosDataType[name]]?.lista,
    };
    return data[name] || data.default;
  };

  const hasSegmentosPersonalizadosInColumn2 = items.some(i => i.name === 'Segmentos personalizados' && i.column === '2');
  const hasRedeInColumn2 = items.some(i => i.name === 'Rede' && i.column === '2');

  const getItemCanDrag = name => {
    const hasShoppingBrasilPermission = clienteData?.tipoAdicionalContratos?.PAN?.includes('SB') ?? false;
    const hasSegmentosPersonalizadosPermission = clienteData?.tipoAdicionalContratos?.PAN?.includes('SEGMENTO_PERSONALIZADO') ?? false;

    if (name === 'Detalhes anúncio') return hasShoppingBrasilPermission;
    if (name === 'Rede') return !hasSegmentosPersonalizadosInColumn2;
    if (name === 'Segmentos personalizados') return hasSegmentosPersonalizadosPermission && !hasRedeInColumn2;

    return true;
  };

  const getItemDisabled = name => {
    const hasShoppingBrasilPermission = clienteData?.tipoAdicionalContratos?.PAN?.includes('SB') ?? false;
    const hasSegmentosPersonalizadosPermission = clienteData?.tipoAdicionalContratos?.PAN?.includes('SEGMENTO_PERSONALIZADO') ?? false;

    if (name === 'Detalhes anúncio') return !hasShoppingBrasilPermission;
    if (name === 'Rede') return hasSegmentosPersonalizadosInColumn2;
    if (name === 'Segmentos personalizados') return !hasSegmentosPersonalizadosPermission || hasRedeInColumn2;

    return false;
  };

  const setDndItemsValue = name => {
    const valueType = {
      Endereço: moduloRelatorioData.enderecoDTO?.endereco,
      Produto: products?.value,
      'CNPJ da Loja': cnpj.value,
      default: moduloRelatorioData[filtrosDataType[name]],
    };
    return valueType[name] || valueType.default;
  };

  const renderSelectValue = (type, name) => {
    if (type === 'select') {
      return <span>{name}</span>;
    }
    return null;
  };

  const returnItemsForColumn = columnName =>
    items
      .filter(item => item.column === columnName)
      .map(item => {
        const canDrag = getItemCanDrag(item.name);
        const disabled = getItemDisabled(item.name);

        return (
          <DndMovableItem
            key={item.id}
            type={item.selectType}
            name={item.name}
            setItems={setItems}
            hasList={item.hasList}
            column={item.column}
            searchable={item.searchable}
            canDrag={canDrag}
            disabled={disabled}
            value={setDndItemsValue(item.name)}
            locale={{
              noResultsText: 'Nenhum item encontrado',
              searchPlaceholder: item.search,
            }}
            data={setSelectDataFilter(item.name)}
            onOpen={() => handleOnOpen(item.name)}
            onSelect={(v, itemSelected) => {
              handleSelect(itemSelected, item.name);
            }}
            onSearch={search => handleSearch(search, item.name)}
            onClean={() => handleClean(item.name)}
            resetProduct={functions?.handleCleanProduct}
            renderValue={() => renderSelectValue(item.selectType, item.name)}
          />
        );
      });

  const handleMoveAllElements = column => {
    const hasShoppingBrasilPermission = clienteData?.tipoAdicionalContratos?.PAN?.includes('SB');
    const hasAD = items.some(i => i.name === 'Detalhes anúncio');
    const keepRedeInColumn1 = column === '2' && hasSegmentosPersonalizadosInColumn2;
    const keepSegmentosPersonalizadosInColumn1 = column === '2' && hasRedeInColumn2;

    const shouldKeepInColumn1 = e =>
      (keepRedeInColumn1 && e.name === 'Rede') || (keepSegmentosPersonalizadosInColumn1 && e.name === 'Segmentos personalizados');

    if (hasAD && !hasShoppingBrasilPermission) {
      setItems(prevState =>
        prevState.map(e => {
          if (e.name === 'Detalhes anúncio') return e;
          if (shouldKeepInColumn1(e)) return e;
          return { ...e, column };
        }),
      );
    } else {
      setItems(prevState =>
        prevState.map(e => {
          if (shouldKeepInColumn1(e)) return e;
          return { ...e, column };
        }),
      );
    }
  };

  useEffect(() => {
    if (returnItemsForColumn('2').length) {
      dispatch(setConsolidadoData(dndName, items));
    } else {
      dispatch(setConsolidadoData(dndName, []));

      items.forEach(i => {
        if (i.column === '1' && moduloRelatorioData[filtrosDataType[i.name]]?.length) {
          handleClean(i.name);
          if (i.name === 'Endereço') {
            dispatch(setEnderecoRaio(null));
          }
        }
      });
    }
  }, [items]);

  useEffect(() => {
    if (showModalConfirmDownload === false) {
      handleMoveAllElements('1');
      handleClean('Produto');
    }
  }, [showModalConfirmDownload]);

  useEffect(() => {
    setItems(dndItems);
  }, [dndItems]);

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="dnd-columns-wrapper">
        <DndColumn name="1" title={columnTitles?.length ? columnTitles[0] : null} className="column first-column" element={elementLeft}>
          {returnItemsForColumn('1')}
        </DndColumn>
        <div className="dnd-buttons-wrapper">
          <Whisper placement="top" speaker={<Tooltip>Selecionar todos</Tooltip>}>
            <Button className="button-send-right" onClick={() => handleMoveAllElements('2')}>
              <img src={chevronRightIcon} alt="" />
            </Button>
          </Whisper>
          <Whisper placement="bottom" speaker={<Tooltip>Limpar todos</Tooltip>}>
            <Button className="button-send-left" onClick={() => handleMoveAllElements('1')}>
              <img src={chevronLeftIcon} alt="" />
            </Button>
          </Whisper>
        </div>
        <DndColumn name="2" title={columnTitles?.length ? columnTitles[1] : null} className="column second-column" element={elementRight}>
          {returnItemsForColumn('2')}
          {returnItemsForColumn('2').some(item => item.props.name === 'Endereço') ? <DndSelectRaio /> : null}
        </DndColumn>
      </div>
    </DndProvider>
  );
};

export default DndComponent;
